export function formatPaymentMethodLabel(method?: string | null): string {
  const value = String(method ?? "").trim();
  if (!value) return "-";

  return value
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
